import { React } from 'react';

import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from '../components/protectedRoutes';
import ExtintoresBI from '../pages/biSS/extintores';
import FalhasBI from '../pages/biSS/falhas';
import InformacoesTecnicasBI from '../pages/biSS/informacoesTecnicas';
import InformacoesUsinasBI from '../pages/biSS/informacoesUsinas';
import ControleNRsBI from '../pages/biSS/nrs';
import RealEstimadoBI from '../pages/biSS/realEstimado';
import RealEstimadoInversorBI from '../pages/biSS/realEstimadoInversor';
import RelatorioSpeBI from '../pages/biSS/relatorioSpe';

const RouteBISS = () => {
    return (
        <Routes>
            <Route element={<ProtectedRoute role='BISS'/>}>
                <Route path='extintores' element={<ExtintoresBI/>}/>
                <Route path='falhas' element={<FalhasBI/>}/>
                <Route path='informacoesTecnicas' element={<InformacoesTecnicasBI/>}/>
                <Route path='informacoesUsinas' element={<InformacoesUsinasBI/>}/>
                <Route path='nrs' element={<ControleNRsBI/>}/>
                <Route path='realEstimado' element={<RealEstimadoBI/>}/>
                <Route path='realEstimadoInversor' element={<RealEstimadoInversorBI/>}/>
                <Route path='relatorioSpe' element={<RelatorioSpeBI/>}/>
            </Route>
        </Routes>
    );
};

export default RouteBISS;
